// extracted by mini-css-extract-plugin
export default {"message":"Message_message--nas","messageIn":"Message_messageIn--Thg","messageOut":"Message_messageOut--Ttk"};